import { Injectable } from "@angular/core";
import { SessionService } from "./session.service";
import { LocalStorageType } from "../types/localStorage.type";

@Injectable({
    providedIn: 'root',
})
export class TokenService {
    constructor(
        private sessionService: SessionService
    ) {

    }

    set token(token: string | null) {
        localStorage.setItem(LocalStorageType.JwtToken, token!);
    }

    get token(): string | null {
        const hasAccess = this.sessionService.isTokenExpiredOrNull().hasAccess;

        if(!hasAccess)
            return null;

        return localStorage.getItem(LocalStorageType.JwtToken);
    }

    set tokenTomas(token: string | null){
        localStorage.setItem(LocalStorageType.ModaWebToken, token!);
    }

    get tokenTomas(): string | null {
        const hasAccess = this.sessionService.isTokenExpiredOrNull().hasAccess;

        if(!hasAccess)
            return null;

        return localStorage.getItem(LocalStorageType.ModaWebToken);
    } 
}